import carruselIni1 from "../../assets/images/abanderado.jpg";
import carruselIni2 from "../../assets/images/_MG_1624.jpg";
import carruselIni3 from "../../assets/images/salidas12.jpg";
import carruselIni4 from "../../assets/images/lujanGrupo.jpg";
import carruselIni5 from "../../assets/images/_MG_0599.jpg";
import carruselIni6 from "../../assets/images/diadelabandera.jpg";
import carruselIni7 from "../../assets/images/noticia3.jpg";
import carruselIni8 from "../../assets/images/carruserlinicio8.jpg";
import carruselIni9 from "../../assets/images/diaBandera.jpg";
import carruselIni10 from "../../assets/images/diaBandera2.jpg";
import { Link } from "react-router-dom";

const images = [
  {
    src: carruselIni1,
    title: "Más que un colegio, una comunidad educativa",
    text: "Promovemos la excelencia académica, el compromiso y el crecimiento personal de nuestros estudiantes.",
  },
  {
    src: carruselIni2,
    title: "Donde aprender es también expresarse",
    text: "Un espacio donde cada voz, cada arte y cada paso deja huella en la comunidad.",
  },
  {
    src: carruselIni3,
    title: "Experiencias que amplían el aula",
    text: "Actividad interdisciplinar de 1er año en la Reserva de Parque Luro.",
  },
  {
    src: carruselIni4,
    title: "Más que un colegio, una comunidad educativa",
    text: "Promovemos la excelencia académica, el compromiso y el crecimiento personal de nuestros estudiantes.",
  },
  {
    src: carruselIni5,
    title: "Más que un colegio, una comunidad educativa",
    text: "Una propuesta educativa cercana, integral y comprometida con cada trayectoria.",
  },
  {
    src: carruselIni6,
    title: "Crecer juntos en conocimiento y valores",
    text: "Acompañamos aprendizajes significativos con responsabilidad, fe y compromiso.",
  },
  {
    src: carruselIni7,
    title: "Juntos por un futuro mejor",
    text: "Un lugar de aprendizaje, de compartir y de respeto.",
  },
  {
    src: carruselIni8,
    title: "Más que un colegio, una comunidad educativa",
    text: "Una enseñanza de calidad en un entorno afectuoso.",
  },
  {
    src: carruselIni9,
    title: "Día de la Bandera",
    text: "Celebramos nuestras raíces y los valores que nos unen.",
  },
  {
    src: carruselIni10,
    title: "Día de la Bandera",
    text: "Una comunidad que aprende, recuerda y participa.",
  },
];

function ImageCarousel() {
  return (
    <div
      id="myCarousel"
      className="carousel slide home-hero-carousel"
      data-bs-ride="carousel"
      data-bs-interval="4000"
      data-bs-pause="hover"
    >
      <div className="carousel-indicators">
        {images.map((_, index) => (
          <button
            key={index}
            type="button"
            data-bs-target="#myCarousel"
            data-bs-slide-to={index}
            className={index === 0 ? "active" : ""}
            aria-current={index === 0 ? "true" : undefined}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>

      <div className="carousel-inner">
        {images.map((img, index) => (
          <div key={img.src} className={`carousel-item ${index === 0 ? "active" : ""}`}>
            <img src={img.src} className="d-block w-100 home-hero-image" alt={img.title} />
            <div className="home-hero-overlay" />
            <div className="container">
              <div className="carousel-caption home-hero-caption">
                <h1>{img.title}</h1>
                <p>{img.text}</p>

                <Link className="btn home-hero-btn" to="/proyectoEducativo">
                  {index === 2 ? "Galería" : "Ver más"}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true" />
        <span className="visually-hidden">Anterior</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true" />
        <span className="visually-hidden">Siguiente</span>
      </button>
    </div>
  );
}

export default ImageCarousel;
